/**
 * CDB54 Calendrier+ - vue-i18n Configuration
 * Configures internationalization with French as default
 */

import { createI18n } from 'vue-i18n';
import fr from '@/locales/fr.json';

const i18n = createI18n({
  legacy: false,
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: {
    fr,
  },
  globalInjection: true,
});

export default i18n;
